<template>
  <div class="site-shell">
    <header class="site-header">
      <div class="container header-inner">
        <a class="brand" href="#top" aria-label="Shivam Auto Spares home">
          <img src="../assets/brand-mark-web.webp" alt="" width="54" height="54">
          <span>
            <strong>Shivam Auto Spares</strong>
            <small>Two-wheeler spare parts</small>
          </span>
        </a>

        <nav class="desktop-nav" aria-label="Main navigation">
          <a href="#products">Products</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>

        <a class="button button-small header-cta" href="tel:+919811895038">
          Call sales
        </a>
      </div>
    </header>

    <main id="top">
      <section class="hero">
        <div class="container hero-grid">
          <div class="hero-copy">
            <p class="eyebrow">Made for the road ahead</p>
            <h1>Dependable two-wheeler spares, supplied from Delhi.</h1>
            <p class="hero-intro">
              Brake shoes, clutch plates, gaskets, and 100cc spares for
              retailers, workshops, and parts distributors.
            </p>
            <div class="hero-actions">
              <a class="button" href="#products">Explore products</a>
              <a
                class="button button-secondary"
                href="https://wa.me/919811895038?text=Hello%20Shivam%20Auto%20Spares%2C%20I%20have%20a%20product%20inquiry."
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp us
              </a>
            </div>
            <ul class="hero-points" aria-label="Business highlights">
              <li>Wholesale inquiries welcome</li>
              <li>Multiple two-wheeler categories</li>
              <li>Direct sales support</li>
            </ul>
          </div>

          <div class="hero-visual">
            <div class="image-frame">
              <img
                src="../assets/pair-web.webp"
                alt="A pair of P-One two-wheeler brake shoes"
                width="800"
                height="600"
              >
            </div>
            <div class="hero-badge" aria-hidden="true">
              <strong>Delhi</strong>
              <span>Sales office</span>
            </div>
          </div>
        </div>
      </section>

      <section id="products" class="section products-section">
        <div class="container">
          <div class="section-heading">
            <div>
              <p class="eyebrow">Our range</p>
              <h2>Parts that keep two-wheelers moving</h2>
            </div>
            <p>
              Ask our sales team about availability, vehicle compatibility,
              quantities, and trade pricing.
            </p>
          </div>

          <div class="product-grid">
            <article class="product-card product-card-featured">
              <img
                src="../assets/image1-web.webp"
                alt="Two-wheeler brake shoes arranged for inspection"
                loading="lazy"
                width="600"
                height="450"
              >
              <div class="product-copy">
                <span>01</span>
                <h3>Brake shoes</h3>
                <p>
                  Brake shoe sets for a range of commuter two-wheelers and
                  everyday replacement needs.
                </p>
              </div>
            </article>

            <article class="product-card">
              <div class="product-placeholder clutch-art" aria-hidden="true">
                <span></span>
              </div>
              <div class="product-copy">
                <span>02</span>
                <h3>Clutch plates</h3>
                <p>
                  Replacement clutch components for common two-wheeler
                  applications.
                </p>
              </div>
            </article>

            <article class="product-card">
              <div class="product-placeholder gasket-art" aria-hidden="true">
                <span></span>
              </div>
              <div class="product-copy">
                <span>03</span>
                <h3>Gaskets</h3>
                <p>
                  Gasket solutions for maintenance, repair, and engine
                  rebuilding requirements.
                </p>
              </div>
            </article>

            <article class="product-card">
              <img
                src="../assets/image2-web.webp"
                alt="Packaged two-wheeler spare part"
                loading="lazy"
                width="600"
                height="450"
              >
              <div class="product-copy">
                <span>04</span>
                <h3>100cc spares</h3>
                <p>
                  Everyday replacement parts for popular 100cc commuter
                  motorcycles.
                </p>
              </div>
            </article>
          </div>

          <div class="inquiry-strip">
            <p>
              <strong>Looking for a specific part?</strong>
              Send the vehicle model, part name, and quantity to our team.
            </p>
            <a class="text-link" href="mailto:sarthakaggarw254@gmail.com">
              Send an inquiry <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </section>

      <section id="about" class="section about-section">
        <div class="container about-grid">
          <div class="about-photo">
            <img
              src="../assets/pair-web.webp"
              alt="Close-up view of a finished brake shoe set"
              loading="lazy"
              width="700"
              height="700"
            >
          </div>
          <div class="about-copy">
            <p class="eyebrow">About Shivam Auto Spares</p>
            <h2>A practical parts partner for the two-wheeler trade.</h2>
            <p>
              Based in Karol Bagh, New Delhi, we manufacture and trade
              two-wheeler spare parts for businesses that value clear
              communication and dependable supply.
            </p>
            <div class="values-grid">
              <div>
                <strong>Focused range</strong>
                <span>Essential components for commuter two-wheelers.</span>
              </div>
              <div>
                <strong>Trade support</strong>
                <span>Direct help with product and quantity inquiries.</span>
              </div>
              <div>
                <strong>Delhi base</strong>
                <span>Located in Karol Bagh’s automotive market.</span>
              </div>
              <div>
                <strong>Easy contact</strong>
                <span>Reach the sales team by phone, WhatsApp, or email.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" class="section contact-section">
        <div class="container contact-panel">
          <div class="contact-intro">
            <p class="eyebrow">Talk to sales</p>
            <h2>Tell us which parts you need.</h2>
            <p>
              For a faster response, include the vehicle model, part name,
              and required quantity.
            </p>
            <a
              class="button button-light"
              href="https://wa.me/919811895038?text=Hello%20Shivam%20Auto%20Spares%2C%20I%20would%20like%20to%20request%20a%20quote."
              target="_blank"
              rel="noopener noreferrer"
            >
              Request a quote
            </a>
          </div>

          <address class="contact-details">
            <div>
              <span>Sales office</span>
              <p>
                1495/25, Naiwala, Karol Bagh<br>
                New Delhi 110005, India
              </p>
            </div>
            <div>
              <span>Phone</span>
              <a href="tel:+919811895038">+91 98118 95038</a>
              <a href="tel:+919891602346">+91 98916 02346</a>
              <a href="tel:+917011187254">+91 70111 87254</a>
            </div>
            <div>
              <span>Email</span>
              <a href="mailto:sarthakaggarw254@gmail.com">
                sarthakaggarw254@gmail.com
              </a>
            </div>
          </address>
        </div>
      </section>
    </main>

    <footer class="site-footer">
      <div class="container footer-inner">
        <p>© {{ currentYear }} Shivam Auto Spares</p>
        <p>Two-wheeler spare parts · New Delhi</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.site-shell {
  --ink: #26211e;
  --muted: #706762;
  --cream: #f3eee6;
  --paper: #fffaf3;
  --green: #a84732;
  --green-dark: #241d1a;
  --lime: #e1b458;
  --line: rgba(38, 33, 30, 0.14);
  min-width: 0;
  overflow: hidden;
  color: var(--ink);
  background: var(--paper);
}

.container {
  width: min(1160px, calc(100% - 40px));
  margin: 0 auto;
}

.site-header {
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

.header-inner {
  display: flex;
  min-height: 88px;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: white;
  text-decoration: none;
}

.brand img {
  border-radius: 50%;
  background: white;
}

.brand span {
  display: flex;
  flex-direction: column;
}

.brand strong {
  font-size: 1rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.brand small {
  margin-top: 3px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: 32px;
}

.desktop-nav a {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  text-decoration: none;
}

.desktop-nav a:hover,
.desktop-nav a:focus-visible {
  color: white;
}

.button {
  display: inline-flex;
  min-height: 52px;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  border: 1px solid var(--lime);
  border-radius: 3px;
  color: var(--green-dark);
  background: var(--lime);
  font-size: 0.83rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-decoration: none;
  text-transform: uppercase;
  transition: transform 180ms ease, background 180ms ease;
}

.button:hover {
  transform: translateY(-2px);
  background: #edc873;
}

.button:focus-visible,
a:focus-visible {
  outline: 3px solid white;
  outline-offset: 4px;
}

.button-small {
  min-height: 42px;
  padding: 0 18px;
  font-size: 0.75rem;
}

.button-secondary {
  border-color: rgba(255, 255, 255, 0.45);
  color: white;
  background: transparent;
}

.button-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
}

.hero {
  position: relative;
  min-height: 760px;
  padding: 160px 0 92px;
  color: white;
  background:
    radial-gradient(circle at 15% 80%, rgba(225, 180, 88, 0.13), transparent 34%),
    var(--green-dark);
}

.hero::after {
  position: absolute;
  right: -160px;
  bottom: -260px;
  width: 620px;
  height: 620px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
}

.hero-grid {
  position: relative;
  z-index: 1;
  display: grid;
  align-items: center;
  grid-template-columns: 1.05fr 0.95fr;
  gap: clamp(48px, 8vw, 110px);
}

.eyebrow {
  margin: 0 0 18px;
  color: #81756e;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.hero .eyebrow,
.contact-section .eyebrow {
  color: var(--lime);
}

h1,
h2,
h3,
p {
  margin-top: 0;
}

h1,
h2 {
  font-family: Georgia, "Times New Roman", serif;
  font-weight: 400;
  letter-spacing: -0.035em;
}

h1 {
  max-width: 680px;
  margin-bottom: 24px;
  font-size: clamp(3.2rem, 6.2vw, 5.8rem);
  line-height: 0.98;
}

.hero-intro {
  max-width: 600px;
  margin-bottom: 32px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 1.08rem;
  line-height: 1.75;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.hero-points {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 26px;
  margin: 36px 0 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.8rem;
  list-style: none;
}

.hero-points li::before {
  margin-right: 9px;
  color: var(--lime);
  content: "•";
}

.hero-visual {
  position: relative;
  max-width: 480px;
  justify-self: end;
}

.image-frame {
  overflow: hidden;
  aspect-ratio: 4 / 5;
  border-radius: 240px 240px 8px 8px;
  background: #d7c7aa;
}

.image-frame img,
.about-photo img,
.product-card > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-frame img {
  object-position: 54% center;
}

.hero-badge {
  position: absolute;
  right: -40px;
  bottom: 28px;
  display: flex;
  width: 116px;
  height: 116px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
  color: var(--green-dark);
  background: var(--lime);
  text-align: center;
}

.hero-badge strong {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.45rem;
  font-weight: 400;
}

.hero-badge span {
  margin-top: 4px;
  font-size: 0.62rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.section {
  padding: 112px 0;
}

.section-heading {
  display: grid;
  align-items: end;
  margin-bottom: 48px;
  grid-template-columns: 1.4fr 0.6fr;
  gap: 48px;
}

h2 {
  max-width: 760px;
  margin-bottom: 0;
  font-size: clamp(2.5rem, 4.5vw, 4.25rem);
  line-height: 1.05;
}

.section-heading > p {
  margin-bottom: 7px;
  color: var(--muted);
  line-height: 1.7;
}

.products-section {
  background: var(--cream);
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.product-card {
  overflow: hidden;
  display: grid;
  min-height: 350px;
  border: 1px solid var(--line);
  background: var(--paper);
  grid-template-columns: 0.9fr 1.1fr;
}

.product-card > img,
.product-placeholder {
  min-height: 350px;
}

.product-copy {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  padding: 34px;
}

.product-copy > span {
  margin-bottom: auto;
  color: #91857e;
  font-size: 0.72rem;
  letter-spacing: 0.12em;
}

.product-copy h3 {
  margin-bottom: 12px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2rem;
  font-weight: 400;
}

.product-copy p {
  margin-bottom: 0;
  color: var(--muted);
  font-size: 0.92rem;
  line-height: 1.65;
}

.product-placeholder {
  position: relative;
  overflow: hidden;
  background: #d7c9b9;
}

.product-placeholder::before,
.product-placeholder::after,
.product-placeholder span {
  position: absolute;
  border: 18px solid rgba(145, 61, 43, 0.68);
  border-radius: 50%;
  content: "";
}

.product-placeholder::before {
  top: 72px;
  left: 52px;
  width: 150px;
  height: 150px;
}

.product-placeholder::after {
  right: -30px;
  bottom: 28px;
  width: 118px;
  height: 118px;
}

.product-placeholder span {
  top: 24px;
  right: -12px;
  width: 74px;
  height: 74px;
  border-width: 10px;
}

.gasket-art {
  background: #d9cdbc;
}

.gasket-art::before,
.gasket-art::after,
.gasket-art span {
  border-color: rgba(114, 76, 46, 0.52);
  border-style: dashed;
}

.inquiry-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 20px;
  padding: 25px 30px;
  color: white;
  background: var(--green);
}

.inquiry-strip p {
  margin: 0;
  line-height: 1.6;
}

.inquiry-strip strong {
  margin-right: 7px;
}

.text-link {
  flex: 0 0 auto;
  color: var(--lime);
  font-weight: 700;
  text-decoration: none;
}

.text-link span {
  margin-left: 8px;
}

.about-grid {
  display: grid;
  align-items: center;
  grid-template-columns: 0.86fr 1.14fr;
  gap: clamp(60px, 9vw, 130px);
}

.about-photo {
  overflow: hidden;
  aspect-ratio: 1 / 1.14;
  border-radius: 4px 180px 4px 4px;
  background: var(--cream);
}

.about-photo img {
  object-position: center;
}

.about-copy > p:not(.eyebrow) {
  max-width: 660px;
  margin: 28px 0 40px;
  color: var(--muted);
  font-size: 1.04rem;
  line-height: 1.75;
}

.values-grid {
  display: grid;
  padding-top: 30px;
  border-top: 1px solid var(--line);
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
}

.values-grid div {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.values-grid strong {
  font-size: 0.88rem;
  text-transform: uppercase;
}

.values-grid span {
  color: var(--muted);
  font-size: 0.88rem;
  line-height: 1.55;
}

.contact-section {
  padding-bottom: 56px;
  color: white;
  background: var(--paper);
}

.contact-panel {
  display: grid;
  padding: clamp(48px, 7vw, 82px);
  background:
    linear-gradient(120deg, rgba(255, 255, 255, 0.025), transparent 60%),
    var(--green-dark);
  grid-template-columns: 1fr 0.8fr;
  gap: clamp(60px, 10vw, 140px);
}

.contact-intro h2 {
  margin-bottom: 24px;
}

.contact-intro > p:not(.eyebrow) {
  max-width: 540px;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.7;
}

.button-light {
  border-color: white;
  color: var(--green-dark);
  background: white;
}

.contact-details {
  display: grid;
  margin: 0;
  font-style: normal;
  gap: 28px;
}

.contact-details div {
  display: flex;
  flex-direction: column;
}

.contact-details span {
  margin-bottom: 9px;
  color: var(--lime);
  font-size: 0.67rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.contact-details p,
.contact-details a {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.96rem;
  line-height: 1.7;
  text-decoration: none;
}

.contact-details a:hover {
  color: white;
  text-decoration: underline;
}

.site-footer {
  padding: 12px 0 30px;
  color: var(--muted);
  background: var(--paper);
  font-size: 0.78rem;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  padding-top: 22px;
  border-top: 1px solid var(--line);
}

.footer-inner p {
  margin: 0;
}

@media (max-width: 900px) {
  .desktop-nav {
    display: none;
  }

  .hero {
    padding-top: 140px;
  }

  .hero-grid,
  .about-grid,
  .contact-panel {
    grid-template-columns: 1fr;
  }

  .hero-visual {
    width: min(84%, 520px);
    justify-self: start;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }

  .about-photo {
    max-width: 600px;
  }

  .contact-panel {
    gap: 52px;
  }
}

@media (max-width: 640px) {
  .container {
    width: min(100% - 28px, 1160px);
  }

  .header-inner {
    min-height: 76px;
  }

  .brand img {
    width: 44px;
    height: 44px;
  }

  .brand small,
  .header-cta {
    display: none;
  }

  .hero {
    min-height: auto;
    padding: 122px 0 72px;
  }

  h1 {
    font-size: clamp(3rem, 14vw, 4.4rem);
  }

  .hero-actions {
    flex-direction: column;
  }

  .hero-actions .button {
    width: 100%;
  }

  .hero-points {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .hero-visual {
    width: calc(100% - 18px);
    margin-top: 12px;
  }

  .hero-badge {
    right: -22px;
    width: 96px;
    height: 96px;
  }

  .section {
    padding: 78px 0;
  }

  .section-heading {
    margin-bottom: 34px;
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .product-card {
    grid-template-columns: 1fr;
  }

  .product-card > img,
  .product-placeholder {
    min-height: 260px;
    max-height: 300px;
  }

  .product-copy {
    min-height: 260px;
    padding: 28px;
  }

  .inquiry-strip {
    align-items: flex-start;
    flex-direction: column;
    padding: 25px;
  }

  .values-grid {
    grid-template-columns: 1fr;
  }

  .contact-section {
    padding: 0;
  }

  .contact-panel {
    width: 100%;
    padding: 64px 24px;
  }

  .footer-inner {
    flex-direction: column;
    gap: 8px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .button {
    transition: none;
  }
}
</style>
